import BaseAPI from '../api'
const path = 'reports'
export interface ReportInterface {
    idDepartment?: number
    idFiscalYear?: number
    keywordLevel1?: string
    keywordLevel2?: string
    keywordLevel3?: string
    keywordLevel4?: string
    endDate?: string;
    startDate?: string;
}

export default class ReportApi extends BaseAPI {

    static getReportSummaryDownload(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary/download`, { params: { ...props }, responseType: 'arraybuffer' },)
            .then((res) => res)
    }
    static getReportSummaryByFileExtention(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-file-extention`, { params: { ...props } })
            .then((res) => res)
    }
    static getReportSummaryByFileExtentionDownload(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-file-extention/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getReportSummaryByDocumentType(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-document-type`, { params: { ...props } })
            .then((res) => res)
    }
    static getReportSummaryByDocumentTypeDownload(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-document-type/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getReportSummaryByDepartment(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-department`, { params: { ...props } })
            .then((res) => res)
    }
    static getReportSummaryByDepartmentDownload(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-department/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getReportSummaryByFiscalyear(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-fiscalyear`, { params: { ...props } })
            .then((res) => res)
    }
    static getReportSummaryByFiscalyearDownload(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/summary-by-fiscalyear/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getReportAllFiles(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/all-files-report`, { params: { ...props } })
            .then((res) => res)
    }
    static getReportAllFilesDownload(props: ReportInterface): Promise<any> {
        return this.api.get(`${path}/all-files-report/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }

}